const BASE_URL = "https://rumours-media.de";

function setMeta(selector, attr, value) {
    const tag = document.querySelector(selector);
    if (tag) tag.setAttribute(attr, value);
}

// ponytail: every route shared one static <title>/description/canonical from index.html
// (CRA has no server-side render per route) - this sets them per page on mount instead.
export function setPageMeta({ title, description, path = "" }) {
    if (title) {
        document.title = title;
        setMeta('meta[property="og:title"]', "content", title);
        setMeta('meta[name="twitter:title"]', "content", title);
    }
    if (description) {
        setMeta('meta[name="description"]', "content", description);
        setMeta('meta[property="og:description"]', "content", description);
        setMeta('meta[name="twitter:description"]', "content", description);
    }
    const url = `${BASE_URL}${path}`;
    setMeta('link[rel="canonical"]', "href", url);
    setMeta('meta[property="og:url"]', "content", url);
}

export function trackEvent(name, params) {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
        window.gtag("event", name, params);
    }
}
